import {VERSION} from '@/config/constants'
import uaParser from 'ua-parser-js'

export const createDevice = (config) => {
  let l
  if (navigator.language) {
    l = navigator.language
  } else if (!!navigator.languages && navigator.languages > 0) {
    l = navigator.languages[0]
  } else {
    l = "en"
  }
  var match = document.cookie.match(RegExp('(?:^|;\\s*)' + "Zoom-Secret" + '=([^;]*)'));
  
  let clientPlatformHost = "zoom-desktop";
  if (config.product != "desktop") clientPlatformHost = "zoom-mobile";

  const { name: deviceOS, version: deviceOSVersion } = uaParser(
    config.userAgent
  ).os;
  
  const browserInfo = config.browserVersion.split("/");
  let deviceName = `${browserInfo[0]} ${browserInfo[1]}`;

  return {
    name: deviceName,
    deviceType: "web",
    locale: l,
    webAppVersion: VERSION,
    clientPlatform: "solo_zoom",
    clientPlatformVersion: VERSION,
    ZoomToken: match ? match[1] : null,
    deviceOS,
    deviceOSVersion,
    clientPlatformHost,
    clientPlatformHostVersion: config.clientVersion,
  };
}
